import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getDangerousProcess () {
   return Api().get("/dangerous-processes");
},
  updateDangerousProcess (params) {
    return Api().put("/dangerous-processes",params);
  },
  addDangerousProcess (params) {
    return Api().post("/dangerous-processes",params);
  },
  getDangerousProcesses (params) {
    return Api().get("/dangerous-processes/"+params);
  },
  deleteDangerousProcess (params) {
    return Api().delete("/dangerous-processes/"+params);
  },
  getDangerousProcessesByCompany (params) {
    return Api().get("/dangerous-processes-company/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/DangerousProcessService.js